// extracted by mini-css-extract-plugin
module.exports = {"moreChip":"ChipsFilterControl_moreChip__m_otE"};